import { FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getShopsRequest } from 'redux/reducers/shops/reducer';

import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { TShop } from 'redux/reducers/shops/types';

const LinearProgressWithLabel = ({ value }: { value: number }) => {
	return (
		<Box sx={{ display: 'flex', alignItems: 'center' }}>
			<Box sx={{ width: '100%', mr: 1 }}>
				<LinearProgress variant="determinate" value={value} />
			</Box>
			<Box sx={{ minWidth: 35 }}>
				<Typography
					variant="body2"
					sx={{ color: 'text.secondary' }}
				>{`${Math.round(value)}%`}</Typography>
			</Box>
		</Box>
	);
};

export const ProgressComponent: FC<{ item: TShop }> = ({ item }) => {
	const dispatch = useDispatch();

	useEffect(() => {
		const timer = setInterval(() => {
			if (item.state === 'ProductsMigrationStarted') {
				dispatch(getShopsRequest());
			}
		}, 800);
		return () => {
			clearInterval(timer);
		};
	}, [dispatch, item]);

	return (
		<Box sx={{ width: '100%' }}>
			{item.state === 'ProductsMigrationStarted' && (
				<LinearProgressWithLabel value={item.migrationStatus ?? 0} />
			)}
		</Box>
	);
};
